export default __webpack_public_path__ + "static/grenette-regular-pro-8d55f19de9dcb1f11ab2f33ffe04051d.woff2";